import React from 'react';

/**
 * Renders a loading spinner, empty state, or children based on state.
 * Eliminates nested ternaries in list/table rendering.
 */
export const LoadingOrEmpty = ({ loading, isEmpty, emptyIcon, emptyMessage, children, testId }) => {
  if (loading) {
    return (
      <div className="text-center py-12" data-testid={testId ? `${testId}-loading` : undefined}>
        <div className="w-12 h-12 border-4 border-[#0A0A0A] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-[#495057] font-['IBM_Plex_Sans']">Cargando...</p>
      </div>
    );
  }
  if (isEmpty) {
    return (
      <div
        data-testid={testId ? `${testId}-empty` : undefined}
        className="text-center py-12 bg-white border border-[#E9ECEF] p-8"
      >
        {emptyIcon}
        <p className="text-[#495057] font-['IBM_Plex_Sans']">{emptyMessage}</p>
      </div>
    );
  }
  return children;
};
